import { useQuery } from '@tanstack/react-query';
import { vacancyApi } from '../vacancyApi';
import { QueryKey } from '@shared/config';

type UseGetVacancyTariffsHistoryOptions = {
  enabled?: boolean;
};

export const useGetVacancyTariffsHistory = (
  vacancyId: number | null | undefined,
  options?: UseGetVacancyTariffsHistoryOptions
) => {
  const { enabled: enabledOption = true } = options ?? {};

  return useQuery({
    queryKey: [QueryKey.GET_VACANCY_TARIFFS_HISTORY, vacancyId],
    queryFn: () => vacancyApi.getVacancyTariffsHistory(vacancyId!),
    enabled: enabledOption && vacancyId != null && vacancyId > 0,
  });
};
